'use client'

import { useEffect, useContext, useState } from 'react'
import { RootContext } from '@/modules/contextService'
import { RootProps } from '../layout'
import ThemeClient from '../v1/ThemeClient'
import MainFooter from '@/components/MainFooter'
import PublisherHeader from '@/components/display/PublisherHeader'
import styles from '../self/styles.module.scss'
import cookieService from '@/modules/cookieService'

function ThemeComponent ({ children }: RootProps) {
  const { rootData } = useContext(RootContext)
  const { user } = rootData
  const [selectedTheme, setSelectedTheme] = useState('')

  useEffect(() => {
    const storedTheme = cookieService.getCookie('theme')
    setSelectedTheme(storedTheme || 'dark')
  }, [])

  return (
    <>
      <ThemeClient theme={selectedTheme}>
        <div className={styles.main}>
          <PublisherHeader user={user} size={'large'} />
          <div className={styles.content}>
            {children}
          </div>
          <MainFooter />
        </div>
      </ThemeClient>
    </>
  )
}

export default ThemeComponent
